import BasePage from "../../../base/BasePage";
import React from "react";
import { addSchemaUseCase } from "../../../usecases/schema/usecases";
import LeavePresenter from "./LeavePresenter";
import CardView from "../../../components/common/CardView";
import RegionTab from "../../../components/common/RegionTab";
import LeaveTablePage from "./leaveTable/LeaveRequest/LeaveTablePage";
import MonetizationRequestPage from "./leaveTable/MonetizationRequests/MonetizationRequestPage";

class LeavePage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new LeavePresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
    };
  }

  render() {
    const tabs = [
      { title: "Leave Requests", content: <LeaveTablePage /> },
      // { title: "Monetization Requests", content: <MonetizationRequestPage /> },
    ];
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Human Resource &gt;{" "}
              <span style={{ color: "#333" }}>Leaves </span>
            </p>
          </div>
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default LeavePage;
